import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { usePrice } from '../../hooks/usePrice';
import { type ProductDetailContext } from '../../types/types';

const Reviews = (): JSX.Element => {
    const { product, reviewPartnerConfiguration } = useFragmentContext<ProductDetailContext>();
    const { price } = usePrice();

    return (
        <div
            className="yotpo yotpo-main-widget yotpo-widget-instance"
            id="yotpo-tabs-main-widget-tab-0"
            data-yotpo-instance-id={reviewPartnerConfiguration.instanceId}
            data-yotpo-product-id={product.productId}
            data-yotpo-name={product.title}
            data-yotpo-url={product.url}
            data-yotpo-image-url={product.images[0].src}
            data-yotpo-price={price.gross.amount}
            data-yotpo-currency={price.gross.currencyCode}
            data-testid="review-test-id"
        />
    );
};

export { Reviews };
